import { useEffect, useState, type RefObject } from 'react';

/**
 * Whether the referenced element crosses the horizontal reading line at the
 * vertical middle of the viewport — the same "is this the section you're looking
 * at" test the Magic Island uses, but as a plain boolean. Drives the grid-scoped
 * Bulk Enquire prompt via the island override, which (unlike a scroll-driven
 * island section) reliably surfaces on the browse pages.
 */
export const useSectionInView = (
    ref: RefObject<HTMLElement | null>,
): boolean => {
    const [inView, setInView] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el || typeof window === 'undefined') return;

        const observer = new IntersectionObserver(
            (entries) => setInView(entries[0]?.isIntersecting ?? false),
            { rootMargin: '-50% 0px -50% 0px', threshold: 0 },
        );
        observer.observe(el);
        return () => observer.disconnect();
    }, [ref]);

    return inView;
};
